import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from '../Iconify';
import { useMemo } from 'react';
import '../../css/machines/MachineStatus.css';

const KNOWN_STATUSES = new Set(['Valide', 'NonConforme', 'AvecReparation']);

const MachineStatus = ({ status }) => {
    const { t } = useTranslation();

    const displayStatus = status && KNOWN_STATUSES.has(status) ? status : null;

    const statusColor = useMemo(() => {
        switch (displayStatus) {
            case 'Valide':
                return '#309129';
            case 'NonConforme':
                return '#F12525';
            case 'AvecReparation':
                return '#F2B310';
            default:
                return 'black';
        }
    }, [displayStatus]);

    const statusIcon = useMemo(() => {
        switch (displayStatus) {
            case 'Valide':
                return 'material-symbols-light:check';
            case 'NonConforme':
                return 'ci:stop-sign';
            case 'AvecReparation':
                return 'entypo:tools';
            default:
                return null;
        }
    }, [displayStatus]);

    const statusLabel = useMemo(() => {
        switch (displayStatus) {
            case 'Valide':
                return 'Valide';
            case 'NonConforme':
                return 'Non conforme';
            case 'AvecReparation':
                return 'Avec réparation';
            default:
                return null;
        }
    }, [displayStatus]);

    if (!displayStatus) {
        return null;
    }

    return (
        <Box className="machines_status_Box" sx={{ color: statusColor, borderColor: statusColor }}>
            <Iconify icon={statusIcon} className="machines_status_icon" />
            <Typography className="machines_status">{t(statusLabel)}</Typography>
        </Box>
    );
};

export default MachineStatus;
